import React, { useState, useEffect } from 'react';
import AgeGateModal from './components/AgeGateModal';
import CookieBanner from './components/CookieBanner';
import Footer from './components/Footer';

import heroVideo from './assets/70100_Carlsberg_FY25_ONT_Activations.mp4';
import pubImage from './assets/Pub_Image_2x.jpg';
import iconImage from './assets/icon_2x.png';

// Utility function to get a cookie by name.
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

// Function to dynamically load GA4 script
function loadGA4Script() {
  // Check if the GA4 script is already added
  if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
    const script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-90GSPVCWTM';
    script.async = true;
    document.head.appendChild(script);
  
    window.dataLayer = window.dataLayer || [];
    function gtag(){ window.dataLayer.push(arguments); }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', 'G-90GSPVCWTM');
  }
}

function App() {
  const [showAgeGate, setShowAgeGate] = useState(true);
  const [cookieConsent, setCookieConsent] = useState(null);

  useEffect(() => {
    // Check for the persistent verification cookie for age gate
    const isOver18 = getCookie("over18") === "true";
    setShowAgeGate(!isOver18);
    
    // Check if the user has provided cookie consent
    const consent = localStorage.getItem('cookieConsent');
    setCookieConsent(consent);
    if (consent === 'accepted') {
      loadGA4Script();
    }
  }, []);

  const handleAgeVerification = (verified) => {
    if (verified) {
      setShowAgeGate(false);
    }
  };

  const handleConsentChange = (value) => {
    setCookieConsent(value);
    localStorage.setItem('cookieConsent', value);
    if (value === 'accepted') {
      loadGA4Script();
    }
  };

  return (
    <div className="page-container">
      {showAgeGate && <AgeGateModal onAgeVerify={handleAgeVerification} />}
      
      {/* Only show CookieBanner if cookie consent has not been accepted */}
      {cookieConsent !== 'accepted' && (
        <CookieBanner onConsentChange={handleConsentChange} />
      )}

      <header className="home-header">
        <h1 className="visuallyhidden">Carlsberg</h1>
      </header>
      <main>
        <div className="hero-section">
          <h2 className="hero-headlne">The Crown Inn, Ashbourne</h2>
          <p className="hero-copy">
            Charlotte and Chris made the switch from Carling to Carlsberg in August 2024
          </p>
          <video className="hero-video" controls preload="auto">
            <source src={heroVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        <img
          src={pubImage}
          className="pub-image"
          alt="The Crown Inn, Ashbourne, Derbyshire"
        />
        <section className="secton-pub">
          <h3 className="section-headline">
            Did you know<br /> Carlsberg is...
          </h3>
          <ul className="section-copy">
            <li className="pub-list-item">
              <span>The best performing standard lager.<sup>1</sup></span>
            </li>
            <li className="pub-list-item">
              <span>The preferred standard lager brand in the UK.<sup>2</sup></span>
            </li>
          </ul>
        </section>
        <section className="secton-switch">
          <h3 className="section-headline">Should you stock us?<br />Probably.</h3>
          <img src={iconImage} className="icon-image" alt="" />
          <a
            className="secton-cta"
            href="https://www.carlsbergmarstons.co.uk/sell-our-brands/trade-enquiry-form/"
          >
            Make the switch
          </a>
        </section>
        <p className="notes">
          1. In England. Volume &amp; volume growth share CGA OPMS MAT DATA (W/E 30/11/2024) 2.
          IPM Ipsos data YTD Q4 2024, P12M UK drinkers vs Carling, Fosters &amp; Coors.
        </p>
      </main>
      
      {/* Footer rendered at the bottom */}
      <Footer />
    </div>
  );
}

export default App;